// 「予算比 95% (実 1,210 vs 予 1,275)」 のような共通 stat バッジ
import type { Direction } from "@shared/api";

export type Sentiment = "positive" | "neutral" | "warning" | "danger" | "unknown";

export function sentimentFromRatio(ratio: number | null | undefined, direction: Direction): Sentiment {
  if (ratio == null) return "unknown";
  const reverse = direction === "lower_is_better";
  const v = reverse ? 2 - ratio : ratio;
  if (direction === "neutral") return "neutral";
  if (v >= 1.05) return "positive";
  if (v >= 1.00) return "neutral";
  if (v >= 0.90) return "warning";
  return "danger";
}

export function sentimentFromDelta(delta: number | null | undefined, direction: Direction): Sentiment {
  if (delta == null) return "unknown";
  const reverse = direction === "lower_is_better";
  const v = reverse ? -delta : delta;
  if (direction === "neutral") return "neutral";
  if (v >= 0.05) return "positive";
  if (v >= 0)    return "neutral";
  if (v >= -0.05) return "warning";
  return "danger";
}

const STYLE: Record<Sentiment, { text: string; bg: string; border: string; arrow?: string }> = {
  positive: { text: "text-blue-700",    bg: "bg-blue-50",    border: "border-blue-200",    arrow: "▲" },
  neutral:  { text: "text-slate-700",   bg: "bg-slate-100",  border: "border-slate-200" },
  warning:  { text: "text-amber-700",   bg: "bg-amber-50",   border: "border-amber-200",   arrow: "▼" },
  danger:   { text: "text-red-700",     bg: "bg-red-50",     border: "border-red-200",     arrow: "▼" },
  unknown:  { text: "text-slate-400",   bg: "bg-slate-50",   border: "border-slate-200" },
};

export function StatPill({ label, value, sentiment, size = "sm" }: {
  label?: string; value: string; sentiment: Sentiment; size?: "xs" | "sm" | "md";
}) {
  const s = STYLE[sentiment];
  const sz = size === "xs" ? "text-[10px] px-1.5 py-0.5"
           : size === "md" ? "text-sm px-2.5 py-1"
                           : "text-xs px-2 py-0.5";
  return (
    <span className={`inline-flex items-center gap-1 rounded ${s.text} ${s.bg} border ${s.border} ${sz} font-medium`}>
      {label && <span className="text-slate-500 font-normal">{label}</span>}
      <span>{value}</span>
      {s.arrow && <span className="text-[8px]">{s.arrow}</span>}
    </span>
  );
}

export const SENTIMENT_BG: Record<Sentiment, string> = {
  positive: "bg-blue-50",
  neutral:  "bg-white",
  warning:  "bg-amber-50",
  danger:   "bg-red-50",
  unknown:  "bg-slate-50",
};
export const SENTIMENT_RING: Record<Sentiment, string> = {
  positive: "ring-blue-200",
  neutral:  "ring-slate-200",
  warning:  "ring-amber-200",
  danger:   "ring-red-300",
  unknown:  "ring-slate-200",
};
